export default __webpack_public_path__ + "static/media/02.32d99a37.jpg";